export const ACTIVATION_CONSTANTS = {
  API_DESCRIPTION: {
    userAlreadyActivated: "USER IS ALREADY ACTIVATED IN THE SYSTEM. USER MAY PROCEED TO LOG IN."
  }
}